import React, { forwardRef, useEffect } from "react";


let today = new Date();
let month = today.getMonth();
let year = today.getFullYear();


const Datepicker = forwardRef((props, ref) => {
  // BUILD
  function build() {
    for (let week = 0; week < 6; week++) {
			let tr = document.createElement('tr');
			ref.current.querySelector('tbody').appendChild(tr);

			for (let day = 0; day < 7; day++) {
				let td = document.createElement('td');
				tr.appendChild(td);
			}
		}

    setCalendar();
  }

  useEffect(build, []);

  // SET CALENDAR
  function setCalendar() {
    let slots  = ref.current.querySelectorAll('tbody td');
    let months = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre'
    ];
    
    ref.current.querySelector('h3').textContent = `${months[month]} ${year}`;

    // Clear slots
    slots.forEach(slot => {
      slot.textContent = '';
      slot.removeAttribute('class');
      slot.removeAttribute('data-date');
    });

    // Set days
    let days_in_month = new Date(year, month+1, 0).getDate();
    let first_weekday = new Date(year, month, 0).getDay();

    for (let i = 0; i < days_in_month; i++) {
      let dataMonth = month+1;
      let dataDay   = i+1;
      let day       = slots[i+first_weekday];

      if ( dataMonth < 10 ) {
        dataMonth = '0' + dataMonth;
      }

      if ( dataDay < 10 ) {
        dataDay = '0' + dataDay;
      }

      day.setAttribute('data-date', `${year}-${dataMonth}-${dataDay}T00:00:00`);
      day.setAttribute('data-value', `${dataDay}/${dataMonth}/${year}`);
      day.textContent = i+1;
    }

    slots.forEach(slot => {
      // Set today
      if ( new Date(slot.getAttribute('data-date')).getTime() == today.setHours(0,0,0,0) ) {
        slot.classList.add('today');
      }

      // Block empty slots
      if ( slot.textContent == '' ) {
        slot.classList.add('empty');
      }

      // Set previous selection
      let prevDateSelected = ref.current.getAttribute('data-date');

      if ( prevDateSelected && slot.getAttribute('data-date') == prevDateSelected ) {
        slot.classList.add('selected');
      }

      slot.addEventListener('click', select);
    });
  }

  // NAVIGATE
  function prev() {
    month -= 1;

    if (month < 0) {
      month = 11;
      year -= 1;
    }

    setCalendar();
  }

  function next() {
    month += 1;

    if (month > 11) {
      month = 0;
      year += 1;
    }

    setCalendar();
  }

  function close(e) {
    ref.current.style.display = 'none';
  }

  // SELECT
  function select(e) {
    let prev     = ref.current.querySelector('.selected');
    let selected = e.currentTarget;

    prev && prev.classList.remove('selected');
    selected.classList.add('selected');
    ref.current.setAttribute('data-date', selected.getAttribute('data-date'));
    
    // On Change
    props.onchange(selected.getAttribute('data-value'));
  }
  

  return (
    <div ref={ref} className="ds-datepicker" onMouseDown={e => e.preventDefault()}>
      <header>
        <button type="button" onClick={prev}></button>
        <h3></h3>
        <button type="button" onClick={next}></button>
      </header>

      <table>
        <thead>
          <tr>
            <th>Lu</th>
            <th>Ma</th>
            <th>Mi</th>
            <th>Ju</th>
            <th>Vi</th>
            <th>Sa</th>
            <th>Do</th>
          </tr>
        </thead>

        <tbody></tbody>
      </table>

      <button type="button" onClick={close}>Cerrar</button>
    </div>
  )
});

export default Datepicker;


/*

Usage:

<Datepicker onchange={} />

- onchange: Function(date)

*/